export default __webpack_public_path__ + "static/media/badge-2.2e13736f.png";